// import { CircularProgress, Box } from '@material-ui/core'
import { CircularProgress, Box } from '@mui/material';

const CustomLoadingOverlay = ({ isLoading = true }) => {
  return isLoading
    ? (
      <>
        <Box
          sx={{
            position: 'absolute',
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(5px)',
            '@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
              background: 'rgba(255, 255, 255, 0.8)',
            },
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: '1000',
          }}
        >
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1000',
          }}
        > <CircularProgress /> </Box>
      </>
    )
    : null
}

export default CustomLoadingOverlay
